import { featureFlags } from '@shared-services/feature-flags';
import { useEffect, useState } from 'react';
import { logBookingError } from '../loggingUtils';

const getLabelsUrl = (language: string) =>
    `${featureFlags.getProperty(
        'common.resources.cdn.host'
    )}/booking/cal-atoms-locales/cal-locales/${language}.json`;

const loadLabelsByLanguage = async (language: string) => {
    const url = getLabelsUrl(language);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(
            `Failed to load labels from ${url}: ${response.statusText}`
        );
    }
    return response.json();
};

const useBookerLabels = (language: string) => {
    const [labels, setLabels] = useState<Record<string, string> | undefined>(
        undefined
    );
    const [labelsLoaded, setLabelsLoaded] = useState(false);

    useEffect(() => {
        const loadLabels = async () => {
            try {
                if (language) {
                    const labels = await loadLabelsByLanguage(language);
                    setLabels(labels);
                }
            } catch (error) {
                logBookingError('Failed to load labels', {
                    language,
                    errorMessage:
                        // Type guard to handle the error case
                        error instanceof Error
                            ? error.message
                            : 'Unknown error',
                });
            } finally {
                setLabelsLoaded(true);
            }
        };

        loadLabels();
    }, [language]);

    return { labels, labelsLoaded };
};

export default useBookerLabels;
